import React, { useState } from "react";
import "./Internshipform.css";

function InternshipForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    qualification: "",
    domain: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});

  /* ===== Common Change Handler ===== */
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "name") {
      let val = value
        .replace(/[^a-zA-Z ]/g, "")
        .replace(/\s+/g, " ")
        .trimStart();
      if (val.length > 100) val = val.slice(0, 100);
      setFormData({ ...formData, name: val });
      return;
    }

    if (name === "mobile") {
      let val = value.replace(/[^0-9]/g, "");
      if (val.length > 10) val = val.slice(0, 10);
      setFormData({ ...formData, mobile: val });
      return;
    }

    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  /* ===== Validation ===== */
  const validate = () => {
    let newErrors = {};

    // Name
    if (!formData.name) {
      newErrors.name = "!Name is required";
    } else if (
      !/^[A-Z][a-z]*(\s[A-Z][a-z]*)*$/.test(formData.name)
    ) {
      newErrors.name =
        "!Each word must start with capital letter (e.g. John Doe)";
    }

    // Email
    if (!formData.email) {
      newErrors.email = "!Email is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      newErrors.email = "!Invalid email format";
    }

    // Mobile
    if (!formData.mobile) {
      newErrors.mobile = "!Mobile number is required";
    } else if (formData.mobile.length < 10) {
      newErrors.mobile = " !Mobile number must be 10 digits";
    }

    // Qualification
    if (!formData.qualification) {
      newErrors.qualification = "!Qualification is required";
    }

    // Domain
    if (!formData.domain) {
      newErrors.domain = "!Please select internship domain";
    }

    // Resume
    if (!formData.resume) {
      newErrors.resume = "Resume is required";
    } else if (formData.resume.type !== "application/pdf") {
      newErrors.resume = "!Only PDF file allowed";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ===== Submit ===== */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    alert("🎉 Internship form submitted successfully!");

    setFormData({
      name: "",
      email: "",
      mobile: "",
      qualification: "",
      domain: "",
      resume: null,
    });

    setErrors({});
    e.target.reset();
  };

  return (
    <div className="internship-form">
      <h1>Internship Application Form</h1>
      <p className="subtitle">Fill the details to apply for internship</p>

      <form onSubmit={handleSubmit} noValidate>
        {/* Name */}
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="John Doe"
          />
          {errors.name && <small className="error">{errors.name}</small>}
        </div>

        {/* Email */}
        <div className="form-group">
          <label>Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="example@email.com"
          />
          {errors.email && <small className="error">{errors.email}</small>}
        </div>

        {/* Mobile */}
        <div className="form-group">
          <label>Mobile Number</label>
          <input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="10 digit number"
          />
          {errors.mobile && <small className="error">{errors.mobile}</small>}
        </div>

        {/* Qualification */}
        <div className="form-group">
          <label>Highest Qualification</label>
          <input
            type="text"
            name="qualification"
            value={formData.qualification}
            onChange={handleChange}
            placeholder="BCA / MCA / BCS / MCS"
          />
          {errors.qualification && (
            <small className="error">{errors.qualification}</small>
          )}
        </div>

        {/* Domain */}
        <div className="form-group">
          <label>Internship Domain</label>
          <select
            name="domain"
            value={formData.domain}
            onChange={handleChange}
          >
            <option value="">Select Domain</option>
            <option>Full Stack Java</option>
            <option>Web Development</option>
            <option>.NET Developer</option>
            <option>Python Developer</option>
          </select>
          {errors.domain && <small className="error">{errors.domain}</small>}
        </div>

        {/* Resume */}
        <div className="form-group">
          <label>Upload Your Resume (PDF)</label>
          <input
            type="file"
            name="resume"
            accept=".pdf"
            onChange={handleChange}
          />
          {errors.resume && <small className="error">{errors.resume}</small>}
        </div>

        <button type="submit">Apply</button>
      </form>
    </div>
  );
}

export default InternshipForm;

